<template>
    <v-form ref="form" data-cy="vouchers-settings" class="pt-4">
        <v-row no-gutters class="pb-4 gc-4 gr-4">
            <v-col cols="12" lg="4" md="5">
                <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('header_footer_for_vouchers') }}
                </div>
                <v-checkbox
                    v-model="formData.showTOInfo"
                    hide-details
                    :label="$t('show_TO_info')"
                    data-cy="show-TO-info"
                />
                <v-checkbox
                    v-model="formData.showTAInfo"
                    hide-details
                    :label="$t('show_TA_info')"
                    data-cy="show-TA-info"
                />
                <v-checkbox
                    v-model="formData.showSupplierInfo"
                    hide-details
                    :label="$t('show_supplier_info')"
                    data-cy="show-supplier-info"
                />
            </v-col>
            <v-col cols="12" lg="4" md="5">
                <div class="text-subtitle-1 font-weight-medium">
                    {{ $t('vouchers_for_external_suppliers') }}
                </div>
                <v-radio-group v-model="formData.useSpecificVoucherForExternalSuppliers">
                    <v-radio
                        :label="$t('use_specific_voucher_for_external_suppliers')"
                        :value="true"
                        data-cy="use-specific-voucher-for-external-suppliers"
                    />
                    <div class="pl-8">
                        <div>{{ $t('additionally') }}:</div>
                        <v-selection-control-group v-model="formData.showHeaderWithTOAndTAInfo">
                            <v-checkbox
                                hide-details
                                :label="$t('show_TO_TA_info')"
                                data-cy="show-TO-TA-info"
                                :disabled="!formData.useSpecificVoucherForExternalSuppliers"
                            />
                        </v-selection-control-group>
                        <v-selection-control-group v-model="formData.showSupplierLogo">
                            <v-checkbox
                                hide-details
                                :label="$t('dont_show_supplier_logo')"
                                data-cy="dont-show-supplier-logo"
                                :disabled="!formData.useSpecificVoucherForExternalSuppliers"
                            />
                        </v-selection-control-group>
                    </div>
                    <v-radio
                        :label="$t('not_use_specific_voucher_for_external_suppliers')"
                        :value="false"
                        data-cy="not-use-specific-voucher-for-external-suppliers"
                        @click="updateFormData"
                    />
                </v-radio-group>
            </v-col>
        </v-row>
        <div class="pb-4">
            <div class="text-subtitle-1 font-weight-medium">{{ $t('vouchers_note_title') }}</div>
            <div class="text-medium-emphasis font-italic" v-html="$t('vouchers_note')" />
        </div>
        <v-btn :disabled="isLoading" data-cy="save" @click="save">
            {{ $t('save') }}
        </v-btn>
    </v-form>
</template>
<script setup lang="ts">
    const isLoading = ref<boolean>(false)
    const formData = ref({})

    const {$api, $toast} = useNuxtApp()
    const {t} = useI18n()

    onMounted(async () => {
        await loadData()
    })

    async function loadData(): Promise<void> {
        isLoading.value = true
        try {
            formData.value = await $api.voucherSettings.get()
        } catch (e) {
            $toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    const updateFormData = () => {
        formData.value.showHeaderWithTOAndTAInfo = true
        formData.value.showSupplierLogo = true
    }

    const save = async () => {
        isLoading.value = true
        try {
            await $api.voucherSettings.put(formData.value)
            $toast.success(t('success_message.saved_successfully'))
        } catch (e) {
            $toast.error(e.msg || e.errors[0].message)
        } finally {
            isLoading.value = false
        }
    }
</script>
